// src/config/api.js

// ✅ Base para que funcione desde cualquier dispositivo:
// si abrís el front en http://192.168.100.21:3000, la API será http://192.168.100.21:4000
export const API_BASE = window.location.origin.replace(':3000', ':4000');

export const API_ENDPOINTS = {
  // LOGIN
  loginAdmin: `${API_BASE}/api/login`,
  loginProfesor: `${API_BASE}/api/loginprofesor`,

  // COLEGIOS / SALAS / EQUIPOS
  colegios: `${API_BASE}/api/colegios`,
  salas: `${API_BASE}/api/salas`,
  equipos: `${API_BASE}/api/equipos`,

  // (si tu backend tiene rutas filtradas por IDs)
  salasPorColegio: (colegioId) => `${API_BASE}/api/salas/colegio/${colegioId}`,
  equiposPorSala: (salaId) => `${API_BASE}/api/equipos/sala/${salaId}`,

  // PEDIDOS (general)
  pedidos: `${API_BASE}/api/pedidos`,
  pedidoPorId: (id) => `${API_BASE}/api/pedidos/${id}`,
  pedidosPorProfesor: (profesorId) => `${API_BASE}/api/pedidos/profesor/${profesorId}`,

  // COMPONENTES
  componentes: `${API_BASE}/api/componentes`,

  // PEDIDOS DE COMPONENTES (si existe en tu backend)
  pedidosComponentes: `${API_BASE}/api/pedidos-componentes`,
  pedidoComponentePorId: (id) => `${API_BASE}/api/pedidos-componentes/${id}`,

  // EXPORTACIONES (ajustaremos según cómo esté en tu servidor.js)
  exportarExcel: `${API_BASE}/api/exportar/excel`,
  exportarPdf: `${API_BASE}/api/exportar/pdf`,
};